<template>
  <success :show-promotes='false'>
    <thanks :email='email' :title="title">
      <zm-button size='large' round type='primary' @click='goSDK'> {{ $t('billing.success.sdk_btn') }}</zm-button>
      <template #reminder>
        <span>{{ $t('billing.success.need_help_getting_started') }}&nbsp;</span>
        <a href="https://developers.zoom.us/docs/video-sdk/">{{ $t('billing.success.view_doc') }}</a>
      </template>
    </thanks>
  </success>
</template>
<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import common from '@/views/succezz/mixin/common';

export default {
  name: "VideoSDK",
  mixins: [common],
  components: { Success, Thanks },
  methods: {
    goSDK() {
      this.$tracking.buyInteraction(`purchase confirmation`, 'start building your app');
      window.location.href = 'https://marketplace.zoom.us/develop/create'
    },
  },
}
</script>
